// Define custom behavior for scroll position between the routes.
// 'scrollBehavior' can also be defined in nuxt.config.coffee, but it throws a deprecation warning.
// https://nuxtjs.org/docs/configuration-glossary/configuration-router/#scrollbehavior

const isArticleListingPage = (route) => {
	// Is it a route with no filters?
	if (route.path == '/articles') { return true }
	// Is it a route with filters?
	if (route.path.startsWith('/articles') && route.name.startsWith('category-page-articles-listing')) { return true }
	// Not a listing page.
	return false
}

const isRecipeListingPage = (route) => {
	// Is it a route with no filters?
	if (route.path == '/recipes') { return true }
	// Is it a route with filters?
	if (route.path.startsWith('/recipes') && route.name.startsWith('category-page-recipe-listing')) { return true }
	// Not a listing page.
	return false
}

const isProductListingPage = (route) => {
	if (route.path.startsWith('/collections')) { return true }
	return false
}

export default (to, from, savedPosition) => {
	// Don't scroll to top if we're navigating between two...
	// ...article listing pages...
	if(isArticleListingPage(to) && isArticleListingPage(from)) { return }
	// ...recipe listing pages...
	if(isRecipeListingPage(to) && isRecipeListingPage(from)) { return }
	// ...or product listing pages.
	if(isProductListingPage(to) && isProductListingPage(from)) { return }
	// This prevents scroll jump when we toggle the deep link Algolia filters.

	// Else, scroll to top.
	return { y: 0 }
}
